module.exports = __webpack_public_path__ + "img/anatomy-head.142ef5de.png";